import { render, staticRenderFns } from "./VariableRegio.vue?vue&type=template&id=2892b6a5&"
import script from "./VariableRegio.vue?vue&type=script&lang=js&"
export * from "./VariableRegio.vue?vue&type=script&lang=js&"
import style0 from "./VariableRegio.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports